import React, { useState } from "react";
import { MdPhone } from "react-icons/md";
import { Order } from "../utils/type";
import { validateTaiwanPhone } from "@components/form/validate/vaildateTaiwanPhone";

const ContactPhone = ({
  order,
  setOrder,
}: {
  order: Order;
  setOrder: React.Dispatch<React.SetStateAction<Order>>;
}) => {
  const [phoneError, setPhoneError] = useState<string | null>(null);

  const handlePhoneChange = (value: string) => {
    const digitsOnly = value.replace(/\D/g, "").slice(0, 11);
    setOrder((prev) => ({ ...prev, phone: digitsOnly }));
    if (phoneError) {
      const isValid = !digitsOnly || validateTaiwanPhone(digitsOnly);
      setPhoneError(isValid ? null : "請輸入有效的手機（09 開頭 10 碼）或市話（含區碼）");
    }
  };

  const handlePhoneBlur = () => {
    const v = order.phone.trim();
    if (!v) {
      setPhoneError(null);
      return;
    }
    setPhoneError(validateTaiwanPhone(v) ? null : "請輸入有效的手機（09 開頭 10 碼）或市話（含區碼）");
  };

  return (
    <div className="bg-white rounded-2xl p-6 shadow-lg">
      <div className="flex items-center space-x-3 mb-4">
        <div className="p-2.5 bg-blue-100 rounded-xl">
          <MdPhone className="text-blue-600 w-4 h-4" />
        </div>
        <h2 className="text-md font-bold text-gray-800">訂單聯絡電話</h2>
      </div>
      <input
        type="tel"
        inputMode="tel"
        value={order.phone}
        onChange={(e) => handlePhoneChange(e.target.value)}
        onBlur={handlePhoneBlur}
        className={`w-full p-3.5 border-2 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all font-medium ${phoneError ? "border-red-400" : "border-gray-200"}`}
        placeholder="請輸入聯絡電話（手機 09 開頭或市話含區碼）"
      />
      {phoneError && <p className="mt-1.5 text-sm text-red-500">{phoneError}</p>}
    </div>
  );
};

export default ContactPhone;
